import { defineStore } from 'pinia';

import { isDefined, performanceMark, PerformancePoint } from '@libs/utils';

import { useRouterStore } from './routerStore';

export const usePerformanceStore = defineStore('PerformanceStore', () => {
  const routerStore = useRouterStore();

  // State
  let hasTrackedItineraryPricesPerformance = false;
  let hasTrackedBuildYourTripPagePerformance = false;
  let hasTrackedTripOverviewPagePerformance = false;
  let hasTrackedHotelSelectionPagePerformance = false;
  let hasTrackedHotelDetailsPagePerformance = false;
  let hasTrackedActivitySelectionPagePerformance = false;
  let hasTrackedActivityDetailsPagePerformance = false;
  let hasTrackedFlightSelectionPagePerformance = false;
  let hasTrackedFerrySelectionPagePerformance = false;

  // Actions
  function trackItineraryPricesRenderedPerformance(): void {
    const isFirstTripPlannerPage = !isDefined(
      routerStore.previousTripPlannerPage
    );

    if (isFirstTripPlannerPage && !hasTrackedItineraryPricesPerformance) {
      hasTrackedItineraryPricesPerformance = true;
      performanceMark(PerformancePoint.ItineraryPricesRendered);
    }
  }

  function trackBuildYourTripPageRenderedPerformance(): void {
    if (!hasTrackedBuildYourTripPagePerformance) {
      hasTrackedBuildYourTripPagePerformance = true;
      performanceMark(PerformancePoint.BuildYourTripPageRendered);
    }
  }

  function trackTripOverviewPageRenderedPerformance(): void {
    if (!hasTrackedTripOverviewPagePerformance) {
      performanceMark(PerformancePoint.TripOverviewPageRendered);
    }
  }

  function trackTripOverviewPageRenderedWithContentPerformance(): void {
    if (!hasTrackedTripOverviewPagePerformance) {
      hasTrackedTripOverviewPagePerformance = true;
      performanceMark(PerformancePoint.TripOverviewPageRenderedWithContent);
    }
  }

  function trackHotelSelectionPageRenderedPerformance(): void {
    if (!hasTrackedHotelSelectionPagePerformance) {
      performanceMark(PerformancePoint.HotelSelectionPageRendered);
    }
  }

  function trackHotelSelectionPageRenderedWithContentPerformance(): void {
    if (!hasTrackedHotelSelectionPagePerformance) {
      hasTrackedHotelSelectionPagePerformance = true;
      performanceMark(PerformancePoint.HotelSelectionPageRenderedWithContent);
    }
  }

  function trackHotelDetailsPageRenderedPerformance(): void {
    if (!hasTrackedHotelDetailsPagePerformance) {
      performanceMark(PerformancePoint.HotelDetailsPageRendered);
    }
  }

  function trackHotelDetailsPageRenderedWithContentPerformance(): void {
    if (!hasTrackedHotelDetailsPagePerformance) {
      hasTrackedHotelDetailsPagePerformance = true;
      performanceMark(PerformancePoint.HotelDetailsPageRenderedWithContent);
    }
  }

  function trackActivitySelectionPageRenderedPerformance(): void {
    if (!hasTrackedActivitySelectionPagePerformance) {
      performanceMark(PerformancePoint.ActivitySelectionPageRendered);
    }
  }

  function trackActivitySelectionPageRenderedWithContentPerformance(): void {
    if (!hasTrackedActivitySelectionPagePerformance) {
      hasTrackedActivitySelectionPagePerformance = true;
      performanceMark(
        PerformancePoint.ActivitySelectionPageRenderedWithContent
      );
    }
  }

  function trackActivityDetailsPageRenderedPerformance(): void {
    if (!hasTrackedActivityDetailsPagePerformance) {
      performanceMark(PerformancePoint.ActivityDetailsPageRendered);
    }
  }

  function trackActivityDetailsPageRenderedWithContentPerformance(): void {
    if (!hasTrackedActivityDetailsPagePerformance) {
      hasTrackedActivityDetailsPagePerformance = true;
      performanceMark(PerformancePoint.ActivityDetailsPageRenderedWithContent);
    }
  }

  function trackFlightSelectionPageRenderedPerformance(): void {
    if (!hasTrackedFlightSelectionPagePerformance) {
      performanceMark(PerformancePoint.FlightSelectionPageRendered);
    }
  }

  function trackFlightSelectionPageRenderedWithContentPerformance(): void {
    if (!hasTrackedFlightSelectionPagePerformance) {
      hasTrackedFlightSelectionPagePerformance = true;
      performanceMark(PerformancePoint.FlightSelectionPageRenderedWithContent);
    }
  }

  function trackFerrySelectionPageRenderedPerformance(): void {
    if (!hasTrackedFerrySelectionPagePerformance) {
      performanceMark(PerformancePoint.FerrySelectionPageRendered);
    }
  }

  function trackFerrySelectionPageRenderedWithContentPerformance(): void {
    if (!hasTrackedFerrySelectionPagePerformance) {
      hasTrackedFerrySelectionPagePerformance = true;
      performanceMark(PerformancePoint.FerrySelectionPageRenderedWithContent);
    }
  }

  return {
    // Actions
    trackItineraryPricesRenderedPerformance,
    trackBuildYourTripPageRenderedPerformance,
    trackTripOverviewPageRenderedPerformance,
    trackTripOverviewPageRenderedWithContentPerformance,
    trackHotelSelectionPageRenderedPerformance,
    trackHotelSelectionPageRenderedWithContentPerformance,
    trackHotelDetailsPageRenderedPerformance,
    trackHotelDetailsPageRenderedWithContentPerformance,
    trackActivitySelectionPageRenderedPerformance,
    trackActivitySelectionPageRenderedWithContentPerformance,
    trackActivityDetailsPageRenderedPerformance,
    trackActivityDetailsPageRenderedWithContentPerformance,
    trackFlightSelectionPageRenderedPerformance,
    trackFlightSelectionPageRenderedWithContentPerformance,
    trackFerrySelectionPageRenderedPerformance,
    trackFerrySelectionPageRenderedWithContentPerformance,
  };
});
